// extracted by mini-css-extract-plugin
export default {"melodyVideo":"tK-z","isFullWidth":"uK-z","landingPageVideo":"vK-z","play":"wK-z","iframeVideo":"xK-z","playHidden":"yK-z","fullwidth":"zK-z"};